webpackJsonp([9],{

/***/ "./react/school-master/app-keys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MY_SCHOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MY_SCHOOLS_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MY_SAVED_SCHOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_SCHOOL_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCHOOL_BROWSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHOOL_TRIGGER; });
var MY_SCHOOLS = 'MY_SCHOOLS';
var MY_SCHOOLS_SETTINGS = 'MY_SCHOOLS_SETTINGS';
var MY_SAVED_SCHOOLS = 'MY_SAVED_SCHOOLS';
var SAVE_SCHOOL_BUTTON = 'SAVE_SCHOOL_BUTTON';
var SCHOOL_BROWSER = 'SCHOOL_BROWSER';
var SCHOOL_TRIGGER = 'SCHOOL_TRIGGER';

/***/ }),

/***/ "./react/school-trigger.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_school_master_app_keys__ = __webpack_require__("./react/school-master/app-keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_school_trigger_constants_action_types__ = __webpack_require__("./react/school-trigger/constants/action-types.js");



window.addEventListener("load", function () {
    if (!window.AboundSchoolMaster) return;

    var dispatch = function dispatch(action) {
        var store = window.AboundSchoolMaster.getStore(__WEBPACK_IMPORTED_MODULE_0_app_school_master_app_keys__["c" /* SCHOOL_TRIGGER */], appIndex);
        store && store.dispatch(action);
    };

    var appIndex = window.AboundSchoolMaster.registerApp(__WEBPACK_IMPORTED_MODULE_0_app_school_master_app_keys__["c" /* SCHOOL_TRIGGER */], {
        state: {},
        reducer: function reducer(x) {
            return x;
        },
        components: []
    });

    window.AboundSchoolTrigger = {
        openLogin: function openLogin() {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_app_school_trigger_constants_action_types__["a" /* OPEN_LOGIN */] });
        },
        openSignup: function openSignup() {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_app_school_trigger_constants_action_types__["a" /* OPEN_LOGIN */] });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_app_school_trigger_constants_action_types__["b" /* SHOW_SIGNUP */] });
        }
    };
});

/***/ }),

/***/ "./react/school-trigger/constants/action-types.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_SIGNUP; });
var OPEN_LOGIN = 'OPEN_LOGIN';
var SHOW_SIGNUP = 'SHOW_SIGNUP';

/***/ })

},["./react/school-trigger.js"]);


// WEBPACK FOOTER //
// scripts/school-trigger.d075e11b60a6b8e95314.js